export default __webpack_public_path__ + "static/media/07_Foxconn.1b65d570.png";